import { Grid, Typography } from "@mui/material";

const RenderSpeedCoachingText = (): React.JSX.Element => (
  <Grid
    item
    xs={12}
    sm={6}
    md={3}
    sx={{
      display: "flex",
      alignItems: "center",
    }}
  >
    <Typography variant="body1" color="initial">
      Speedcoaching
    </Typography>
  </Grid>
);

export default RenderSpeedCoachingText;
